module.exports = __webpack_public_path__ + "static/1-3867ec5509b51f44ff274ffeb652b629.jpg";